var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolderGoto = function SvgFolderGoto(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.882 9.501",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M.5 5.83a.5.5 0 0 1-.5-.5V1.5a.5.5 0 1 1 1 0v3.33h2.5v1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M14.789 9.501h-10.2a1.107 1.107 0 0 1-1.094-1.1V5.824h4.6l-.973.974a.5.5 0 1 0 .7.7l1.823-1.821a.5.5 0 0 0 0-.7L7.822 3.155a.5.5 0 1 0-.7.7l.973.973H3.5v-3.72A1.11 1.11 0 0 1 4.594.002h4.044a.16.16 0 0 1 .122.055L9.765 1.25h5.025a1.107 1.107 0 0 1 1.093 1.1v6.045a1.11 1.11 0 0 1-1.094 1.106"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolderGoto);
export default ForwardRef;